import { Component, Input, OnInit } from '@angular/core';
import { SidenavItem } from '../../../../../../../library/src/layout/sidenav/sidenav-item/sidenav-item.interface';

@Component({
  selector: 'vr-toolbar-navigation-item',
  templateUrl: './toolbar-navigation-item.component.html',
  styleUrls: ['./toolbar-navigation-item.component.scss']
})
export class ToolbarNavigationItemComponent implements OnInit {

  @Input('item') item: SidenavItem;
  @Input('currentlyOpen') currentlyOpen: SidenavItem[] = [];

  constructor() { }

  ngOnInit() {
  }
}
